import { ApiEndpoints } from "@shared/api/api-endpoints";
import { bxApiClient } from "@shared/api/clients/apiClientFactory";

export const downloadBillTemplate = async (billId: string): Promise<Blob> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `render-dynamic-template/${billId}`
  );
  const response = await bxApiClient.get(url, {
    responseType: "blob",
  });
  return response.data;
};
